import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import useSeo from "../../hooks/useSeo";
import "./Public.css";

const pubUrl = process.env.PUBLIC_URL || "";

const projectTypes = [
  "Deck construction and replacement",
  "Patio planning and installation",
  "Stairs, railings, and access points",
  "Repair work for worn outdoor spaces",
];

const details = [
  {
    title: "Layout",
    body: "Outdoor spaces need to work with doors, grade changes, traffic flow, furniture, shade, and how the yard is actually used.",
  },
  {
    title: "Structure",
    body: "Framing, support, fastening, drainage, and transitions matter as much as the finished surface.",
  },
  {
    title: "Finish",
    body: "Material choices, edge details, railing lines, and cleanup determine whether the project feels intentional when complete.",
  },
];

export default function DeckPatio() {
  useSeo({
    title: "Deck & Patio | Crowned Roofing",
    description:
      "Deck and patio construction services for practical outdoor living spaces, including repairs, replacement, stairs, railings, and layout planning.",
    ogImage: "https://www.crownedroofing.com/images/ogimg.png",
    canonical: "https://www.crownedroofing.com/deck-patio",
  });

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Deck & Patio | Crowned Roofing";
    const meta = document.querySelector("meta[name='description']");
    if (meta) {
      meta.setAttribute(
        "content",
        "Deck and patio construction services for practical outdoor living spaces, including repairs, replacement, stairs, railings, and layout planning."
      );
    }
  }, []);

  return (
    <main className="publicPage deckPage">
      <Header />

      <section className="deckHero">
        <div className="deckHeroBg" aria-hidden="true">
          <img src={`${pubUrl}/images/landing/house.png`} alt="" />
        </div>
        <div className="deckHeroInner">
          <div className="deckHeroCopy">
            <span className="fenceEyebrow">Outdoor construction</span>
            <h1>Decks and Patios Made for Real Use</h1>
            <p>
              Outdoor living spaces planned around structure, access, comfort, and the way
              your property needs to function every day.
            </p>
            <button className="rBtn" onClick={() => navigate("/contact")}>
              REQUEST AN ESTIMATE
            </button>
          </div>
          <div className="deckHeroPanel">
            {projectTypes.map((item) => (
              <div className="deckHeroItem" key={item}>
                {item}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="deckSplit">
        <div className="container deckSplitGrid">
          <div className="deckImageStack" aria-hidden="true">
            <img src={`${pubUrl}/images/residential-img1.png`} alt="" />
            <img src={`${pubUrl}/images/residential-img3.png`} alt="" />
          </div>
          <div className="deckSplitCopy">
            <h2>
              <span className="rAccent" aria-hidden="true" />
              Built beyond the surface
            </h2>
            <p>
              A deck or patio is only successful if it fits the property. The right layout
              makes movement easier, protects usable space, and keeps the finished work from
              feeling forced into the yard.
            </p>
            <p>
              We focus on practical construction decisions first: support, drainage, access,
              transitions, material suitability, and clean finishing details.
            </p>
          </div>
        </div>
      </section>

      <section className="deckDetails">
        <div className="container">
          <div className="fenceSectionHead">
            <h2>What We Plan Around</h2>
            <p>Good outdoor work starts before materials arrive.</p>
          </div>

          <div className="deckDetailGrid">
            {details.map((item) => (
              <article className="deckDetailCard" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="deckBand">
        <div className="deckBandInner">
          <div>
            <h2>Deck, Patio, or Repair Scope</h2>
            <p>
              Whether you need a new outdoor space, a replacement, or targeted repair work,
              the first step is defining what the property actually needs.
            </p>
          </div>
          <button className="rBtn" onClick={() => navigate("/contact")}>
            START THE CONVERSATION
          </button>
        </div>
      </section>

      <Footer />
    </main>
  );
}
